<template lang="pug">
	.audio-tracker--track-overlay
		svg(height="100%", width="100%")
			template(v-for="path in paths")
				path(:d="path.d" :stroke="path.stroke" fill="transparent" :stroke-width="path.strokeWidth", :class="path.class")
				text(v-if="path.texts", v-for="text in path.texts", :x="text.x", :y="text.y", :class="text.class", :fill="text.fill") {{text.value}}
</template>


<script>
	export default {
		translationCategory: 'audioTracker.TrackOverlay',
		name: 'audio-tracker--track-overlay',
		components: {  },
		props: ['tracker', 'tracks', 'showLinksAlways', 'aggregatedTracks'],
		data() {
			return {
			};
		},
		computed: {
			paths() {
				const paths = [];
				const startPoints = [];
				const endPoints = [];
				this.tracks.map(track => {
					if (!track.__trackLineTop) return;
					
					const isSelected = this.tracker.selectedTrackIds.includes(track.id);

					if (!this.showLinksAlways && !isSelected) return;
					let spaceDest = 14;
					let spaceSource = 4;

					paths.push(...track.__linkedTo.map((link) => {
						let destTime = link.linkType === 'start' ? link.track.start : (link.track.start + link.track.trimmedDuration);
						let direction = destTime > (track.start + track.trimmedDuration) ? 1 : -1;

						let destX = destTime * this.tracker.display.pixelsPerSecond - 10 - 10 * direction;
						let destY = link.track.__trackLineTop + link.track.__trackLineHeight - 20;
						
						while(endPoints.filter(f => f[0] === destX && f[1] === destY).length) {
							destY -= endPoints.filter(f => f[0] === destX && f[1] === destY).length * spaceDest;
						}

						let sourceTime = track.start + track.trimmedDuration;
						let sourceX = sourceTime * this.tracker.display.pixelsPerSecond;
						let sourceY = track.__trackLineTop + 20;

						let sourceSpaceX = 0;
						while(startPoints.filter(f => f[0] === sourceX && f[1] === sourceY).length) {
							let count = startPoints.filter(f => f[0] === sourceX && f[1] === sourceY).length;
							sourceSpaceX += count;
							sourceY += count * spaceSource;
						}

						const points = [];

						points.push(['M', sourceX, sourceY]);
						points.push(['l', 10 + sourceSpaceX * spaceSource, 0]);
						points.push(['l', 0, destY - sourceY]);
						points.push(['l', destX - sourceX -sourceSpaceX * spaceSource, 0]);
						points.push(['l', 0, 5]);
						points.push(['l', direction * 10, -5]);
						points.push(['l', direction * -10, -5]);
						points.push(['l', 0, 5]);

						startPoints.push([sourceX, sourceY]);
						endPoints.push([destX, destY]);

						return {
							d: points.map(f => f.join(' ')).join(' '),
							isSelected,
							class: `path-item ${isSelected ? 'selected' : ''}`,
							texts: [{
								x: destX,
								y: destY - 5,
								value: link.sourceLinkType === 'both' ? 'POS' : (link.sourceLinkType === 'start' ? 'STRT' : 'END'),
								class: `text-decoration-small ${isSelected ? 'selected' : ''}`
							}]
						}
					}));
				});
				return paths;
			}
		},
		watch: {
		},
		mounted() {
			if (__DEBUG__)
				window.trackerOverlay = this;
		},
		destroyed() {
		},
		methods: {
			calcSizes() {
				
			}
		}
	};
</script>
<style lang='scss'>
	.audio-tracker--track-overlay {
		@import "main/themes/generated/variables.base.scss";

		position: absolute;
		left: 0px;
		top: 0px;
		width: 100%;
		height: 100%;
		z-index: 10;

		.path-item {
			stroke: #ccc;
			stroke-width: 1;

			&.selected {
				stroke: $base-accent;
				stroke-width: 1;
			}
		}

		.text-decoration-small {
			font-size: 8px;
			fill: #aaa;

			&.selected {
				fill: $base-accent;
			}
		}
	}
</style>
